import './preferences.scss';
import React from 'react';
import {Link, Navigate, useLocation, useNavigate} from 'react-router-dom';
import Header from '../../../organisms/header/header.js';
import RoleRibbonByRole from '../../../organisms/common/role-ribbon/role-ribbon-by-role';
import decodeToken from '../../../../utils/decode-token';
import {useTranslation} from 'react-i18next';
import PreferencesHac from '../../../organisms/common/hac-preferences/org-hac-preferences';
import HacNavigation from "../../../organisms/common/hac-navigation/hac-navigation";
import { canAccessHacManagement, getHacBackPathForRole } from '../../../../utils/role-utils';

const HacListPreferences = () => {
  const {t} = useTranslation();

  const token = sessionStorage.getItem('token') || null;
  const role = decodeToken(token).role;
  const location = useLocation();
  const {breadcrumbName, backPath} = location.state || {};
  const navigate = useNavigate();

  return (
    <>
      {token && canAccessHacManagement(role) ? (
        <div className="App">
          <Header/>
          <RoleRibbonByRole role={role} navigate={navigate} translate={t} />
          <main>
            <section
              className={`${canAccessHacManagement(role) ? 'no-bg' : ''}`}>
              <div
                className="inner menu">
                <HacNavigation />
                <main className="">
                  <Link
                    to={backPath || getHacBackPathForRole(role)}
                    className="back-button"
                  >
                    <span className="icon-chevron-left"></span> {t('common-back')}{' '}
                    / {breadcrumbName}
                  </Link>
                  <h4>{t('pma-preferences-title')}</h4>
                  <main className="preferences">
                    <PreferencesHac/>
                  </main>
                </main>
              </div>
            </section>
          </main>
        </div>
      ) : (
        <Navigate to="/login"/>
      )}
    </>
  );
};

export default HacListPreferences;
